import { updates } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          最新动态
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">第一时间掌握丫丫漫画最新上架与更新资讯</p>
        <div className="space-y-0">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-start gap-3 md:gap-4 py-3.5 md:py-4 ${
                idx < updates.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded bg-accent-100 text-accent-700 whitespace-nowrap mt-0.5 shrink-0">
                {item.tag}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap shrink-0 mt-0.5">
                {item.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}